var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 54,
    viewBox: "0 0 62 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    transform: "translate(0 .286)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.052,
    cy: 22.886,
    fill: "#FFDCE3",
    rx: 22.948,
    ry: 22.886
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    d: "M32.137 47.601c9.255-2.834 14.747-12.61 12.342-22.22-2.465-9.854-12.3-15.824-21.997-13.353C12.786 14.5 6.881 24.482 9.268 34.323l.142.534c.224.838-.397 1.664-1.25 1.664H4.212C2.044 36.52 0 34.748 0 32.566v-6.592c0-2.184 1.74-3.955 3.889-3.955.715 0 1.296.59 1.296 1.319 0 .728-.58 1.318-1.296 1.318-.716 0-1.297.59-1.297 1.318v6.592c0 .624.8 1.318 1.62 1.318h2.31c-2.057-10.913 4.609-21.68 15.33-24.413 11.082-2.825 22.322 3.998 25.14 15.259.774 3.097.832 6.21.277 9.154h2.31c.594 0 .972-.464.972-1.318v-6.592c0-.728-.58-1.318-1.297-1.318-.715 0-1.296-.59-1.296-1.318 0-.729.58-1.319 1.296-1.319 2.148 0 3.889 1.771 3.889 3.955v6.592c0 2.211-1.418 3.955-3.565 3.955h-2.981c-2.126 6.554-7.366 11.91-14.4 13.802C31.674 51.88 30.223 53 28.516 53h-3.889c-2.147 0-3.888-1.77-3.888-3.955 0-2.184 1.74-3.955 3.888-3.955h3.889c1.646 0 3.054 1.04 3.62 2.511zm-7.51.126c-.716 0-1.296.59-1.296 1.318 0 .728.58 1.318 1.296 1.318h3.889c.716 0 1.296-.59 1.296-1.318 0-.728-.58-1.318-1.296-1.318h-3.889zm.324-23.071c0 .728-.58 1.318-1.296 1.318-.715 0-1.296-.59-1.296-1.318 0-2.19 1.512-4.078 3.621-4.52 2.109-.442 4.233.685 5.083 2.697.85 2.011.194 4.354-1.568 5.604-.587.42-.462.324-.607.49-.445.508-.723 1.393-.697 2.957a1.308 1.308 0 0 1-1.273 1.34 1.306 1.306 0 0 1-1.319-1.295c-.037-2.188.444-3.717 1.353-4.756.202-.231.414-.425.646-.604.13-.1.475-.339.41-.292a1.997 1.997 0 0 0 .674-2.403 1.937 1.937 0 0 0-2.179-1.156 1.97 1.97 0 0 0-1.552 1.938z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.086,
    cy: 36.62,
    fill: "#F7465F",
    rx: 1.959,
    ry: 1.962,
    transform: "rotate(-30 27.086 36.62)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTel);
export default __webpack_public_path__ + "static/media/ic-tel.03aae42c5e715f68409416c6985d4d54.svg";
export { ForwardRef as ReactComponent };